import {
  genDefaultItem,
  genDefaultItemWithInfo,
  genMenuItemCopy,
  genMenuItemInfo
} from '@/utils/list-generators';
import { convertDate, getEmptyString } from '@/utils';
import { useCopy } from '@/compositions/copy';
import { usePopup } from '@/compositions/popup';
import { getControlIcon } from '@/modules/linked-objects/ui/linked-object-card/controls/control-icons';
import { toFixed } from 'ol/math';
import { useGeotags } from '@/modules/geotags/compositions/geotags';

const historyItems = {
  monitoringItem: item => {
    const isAlert = item.node.property === 'Alert';
    const isTriggered = item.node.value === 'TRIGGERED';
    const hasAlert = isAlert && item.node.value !== 'OFF';

    return genDefaultItem({
      title: `${item.node.value}`,
      subTitle: convertDate(item.node.recordedAt),
      iconColor: isTriggered ? 'red' : undefined,
      icon: hasAlert ? '$alert_on' : ''
    });
  },
  geoItem: (item, listeners) => {
    return genDefaultItem(
      {
        title: `${toFixed(item.node.value?.lon, 6)}; ${toFixed(
          item.node.value?.lat,
          6
        )};  ${toFixed(item.node.value?.alt, 6)}`,
        subTitle: convertDate(item.node.recordedAt),
        icon: 'mdi-map-marker'
      },
      listeners
    );
  },
  propertyItem: item => {
    const popup = usePopup();
    const { copyWithAlert } = useCopy();
    const isJson = typeof item.node.value === 'object';
    let value = 'n/a';
    let author = 'n/a';

    if (item.node.userByBy?.mName) {
      author = item.node.userByBy?.mName;
    }

    if (item.node.value !== null) {
      value = isJson ? JSON.stringify(item.node.value) : item.node.value;
    }

    return genDefaultItem({
      title: `${item.node.property}: ${value}`,
      actions: [
        genMenuItemInfo(() => {
          popup.open({
            component: () => import('@/components/popup/PropertyInfo.vue'),
            props: {
              property: item.node
            }
          });
        }),
        genMenuItemCopy(async () => copyWithAlert(value))
      ],
      subTitle: `${convertDate(item.node.recordedAt)} by ${author}`,
      showAvatar: false
    });
  },
  controlItem: control => {
    const popup = usePopup();
    const parsedError = control.node.error !== undefined ? JSON.parse(control.node.error) : undefined;
    return genDefaultItemWithInfo({
      title: control.node.name,
      subTitle: `${convertDate(control.node.createdAt)} by ${
        control.node.caller.mName
      }`,
      action: () => {
        popup.open({
          component: () => import('@/components/popup/ControlInfo.vue'),
          props: {
            controlItem: control
          }
        });
      },

      icon: getControlIcon(
        control.node.ack,
        control.node.done,
        parsedError
      )
    });
  },
  geotagItem: item => {
    const { getGeotagById } = useGeotags();

    return genDefaultItem({
      title: getEmptyString(getGeotagById(item.node.value)?.name),
      subTitle: convertDate(item.node.recordedAt),
      icon: 'mdi-map-marker'
    });
  }
};

export default historyItems;
